import { SystemStyleObject } from '@mui/system';
import { FilterFieldSkeleton } from './FilterFieldSkeleton';
import { SideFilters } from './SideFilters';

interface Props {
  showFilters: boolean;
  filterCount?: number;
  heading?: string;
  sx?: SystemStyleObject;
}

export function SideFiltersSkeleton({ showFilters, filterCount = 6, heading, sx }: Props) {
  return (
    <SideFilters showFilters={showFilters} heading={heading} sx={sx}>
      {Array.from({ length: filterCount }, (_, index) => (
        <FilterFieldSkeleton key={index} />
      ))}
    </SideFilters>
  );
}
